@if (showTable) {
  <snelstart-ui-table [config]="tableConfig">
    <snelstart-ui-table-col
      columnType="string"
      name="label"
      [showFilter]="false"
      [showSort]="true"
      width="400px"
      i18n-displayName
    >
      <snelstart-ui-table-col-header>
        Rapportage per {{ this.rapportageDatum | date: 'dd-MM-yyyy' }}
      </snelstart-ui-table-col-header>

      <snelstart-ui-table-expanded-row>
        <div *ngFor="let option of options; let i = index;">
          <!-- Subonderdelen -->
          <div *ngFor="let subOnderdeel of option.subonderdelen!; let j = index;">
            <div *ngIf="subOnderdeel.visible">
              <!-- First-level button -->
              <snelstart-ui-button
                icon="chevron-right" type="link" class="ps-5"
                (click)="navigateToSubPage(subOnderdeel.pageMapping)">
                {{ subOnderdeel.label }}
              </snelstart-ui-button>

              <!-- Subsubonderdelen -->
              <div *ngIf="subOnderdeel.subsubonderdelen">
                <div *ngFor="let subsub of subOnderdeel.subsubonderdelen; let k = index;">
                  <div *ngIf="subsub.visible">
                    <snelstart-ui-button
                      icon="chevron-right"
                      type="link"
                      class="ps-10"
                      (click)="navigateToSubPage(subsub.pageMapping, k)"
                    >
                      {{ subsub.label }}
                    </snelstart-ui-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </snelstart-ui-table-expanded-row>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col name="onderdelenAanvullendeTekst"
                            [showFilter]="false"
                            [showSort]="false"
                            columnType="string"
                            [decimals]="2"
                            i18n-displayName
                            width="250px">
      <snelstart-ui-table-col-header>

      </snelstart-ui-table-col-header>

    </snelstart-ui-table-col>

    <snelstart-ui-table-col name="berekening"
                            [showFilter]="false"
                            [showSort]="false"
                            columnType="currency"
                            [decimals]="2"
                            i18n-displayName
                            width="250px"
    >
      <snelstart-ui-table-col-header>

      </snelstart-ui-table-col-header>

      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          <ng-container>
            <a
              *ngIf="record.value === 1"></a>
          </ng-container>
          <ng-container>
            <a
              *ngIf="record.value === 2"></a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 3"></a>
          </ng-container>
          <ng-container>
            <a
              *ngIf="record.value === 4"></a>
          </ng-container>
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

  </snelstart-ui-table>
  <snelstart-venture-fiscaal-domain-logic-service [(dialogVisible)]="this.dialogVisible"
                                                  [title]="'Nieuwe jaarrapportage aanmaken'"
  >
  </snelstart-venture-fiscaal-domain-logic-service>
}
